import { render, staticRenderFns } from "./NoticiasProcesoIntegracion.vue?vue&type=template&id=ff7374de"
import script from "./NoticiasProcesoIntegracion.vue?vue&type=script&lang=js"
export * from "./NoticiasProcesoIntegracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports